module.exports = __webpack_public_path__ + "img/Icon_comentarios.ba0e1529.svg";